import { IStoreState, IUserState } from 'src/interface';

export const assetsUserSelector = (state: IStoreState): IUserState =>
    state.user;

export const isFollowSeclector = (objectType: Exclude<string, 'soccer'>, objectId: number) => (
    state: IStoreState
): boolean => {
    if (!state.user.follow[objectType] || !Array.isArray(state.user.follow[objectType])) {
        return false;
    }
    return (state.user.follow[objectType] as Array<number>).indexOf(objectId) > -1;
};

export const isBookmarkSeclector = (id: number) => (
    state: IStoreState
): boolean => {
    return state.user.bookmark.indexOf(id) > -1;
};

export const bookmarkSelector = (state: IStoreState): number[] =>
    state.user.bookmark || [];

export const likeSelector = (state: IStoreState): number[] =>
    state.user.like || [];
